// extracted by mini-css-extract-plugin
module.exports = {"container":"Parser_container__RIsJZ","card":"Parser_card__I3Z2-"};